import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '@/modules/shared/constants/query-keys.contant'

import { homeClientReportService } from '../services/home-client-report.service'
import type { TClientReport } from '../types/home-client-report.type'

type CustomersReportsQueryProps = {
  typeDashboard: number
  enabled: boolean
  vendedor?: string
}

export function useCustomersReportsQuery({
  typeDashboard,
  enabled,
  vendedor = '',
}: CustomersReportsQueryProps) {
  const queryKey = [QUERY_KEYS.CLIENTS_REPORTS, typeDashboard, vendedor]

  const {
    data: clientsReports,
    isFetching: isLoadingCustomersReports,
    refetch: refetchCustomersReports,
  } = useQuery<TClientReport[]>({
    queryKey,
    enabled,
    queryFn: async () => {
      const response = await homeClientReportService({
        payload: { typeDashboard },
        vendedor,
      })

      const data = JSON.parse(response.body)
      return data
    },
    staleTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
    retryDelay: 1000,
  })

  return {
    clientsReports,
    isLoadingCustomersReports,
    refetchCustomersReports,
  }
}
